// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"258":"locale-fr","377":"locale-ru","417":"setting","467":"locale-de_ch","870":"locale-pl"}[chunkId] || chunkId) + "." + {"0":"4027abc5","112":"d2e08cdd","258":"ea207493","377":"120b3554","417":"6244ebea","467":"fa454b7a","626":"e5e40771","870":"dd26551f"}[chunkId] + ".js";
};